<template>
  <div>
    <div class="member-detail-wrap" v-if="subjectList">
      <header>
        <h3>{{ cupName }}</h3>
        <div>
          <img style="border-radius: 50%" :src="subjectList.avatar" />
          <dl>
            <dt>{{ subjectList.real_name }}</dt>
            <dd>
              <span>{{ subjectList.uname }}</span>
              <router-link
                :to="{
                  name: 'honorRoll',
                  params: {
                    scheduleId,
                    seasonId,
                    currentSeason,
                    currentAcountId,
                  },
                }"
                >升段光荣榜></router-link
              >
            </dd>
          </dl>
        </div>

        <!-- <div class="share" @click="onSharePlu">
          <span>分享</span>
        </div> -->
      </header>
      <div class="base">
        <div class="cont">
          <!-- <div class="flex-vertically-center  team-contribution" @click="handleContribution">
          团队贡献
        </div> -->
          <div class="flex-space-between row" style="display: none">
            <div class="user-info">
              <div class="avator">
                <img
                  v-if="subjectList.avatar_url"
                  :src="subjectList.avatar_url"
                  alt=""
                />
                <div v-else class="flex-vertically-center run">
                  {{
                    subjectList.real_name &&
                    subjectList.real_name.substring(0, 1)
                  }}
                </div>
              </div>
              <div class="user">
                <span class="name">{{ subjectList.real_name }}</span>
                <span class="id">{{ subjectList.uname }}</span>
              </div>
            </div>
            <div class="share" @click="onSharePlu">
              <span>分享</span>
            </div>
          </div>
          <div class="tabs">
            <div
              class="tab-item"
              :class="currentIndex === index ? 'active' : ''"
              v-for="(item, index) in navTabs"
              :key="index"
              @click="handleTabs(index)"
            >
              <span>{{ item.name }}</span>
            </div>
          </div>
          <template v-if="subjectList">
            <div class="content-box">
              <div class="flex-space-between item-list">
                <div class="flex-flex-start">
                  <img
                    class="icon"
                    src="../../assets/images/winterGame/p1.png"
                  />
                  <div class="name">个人赛季排名：</div>
                </div>
                <div class="ranking">
                  <span
                    >{{
                      (subjectList.season_rank || 0) | formatNumberFilter
                    }}名</span
                  >
                </div>
              </div>
              <div class="flex-space-between item-list">
                <div class="flex-flex-start">
                  <img
                    class="icon"
                    src="../../assets/images/winterGame/level.png"
                  />
                  <div class="name">段位：</div>
                </div>
                <div class="ranking">
                  <span v-if="subjectList.segment_id < 42"
                    >{{ subjectList.segment_name || ""
                    }}{{ subjectList.segment_level }}级</span
                  >
                  <span v-else>{{ subjectList.segment_name }}</span>
                </div>
              </div>
              <div class="flex-space-between item-list">
                <div class="flex-flex-start">
                  <img
                    class="icon"
                    src="../../assets/images/winterGame/p2.png"
                  />
                  <div class="name">奖杯数：</div>
                </div>
                <div class="ranking">
                  {{ (subjectList.pk_score || 0) | formatNumberFilter }}
                </div>
              </div>
              <div class="flex-space-between item-list">
                <div class="flex-flex-start">
                  <img
                    class="icon"
                    src="../../assets/images/winterGame/p3.png"
                  />
                  <div class="name">胜率：</div>
                </div>
                <div class="ranking">
                  {{ Math.round(subjectList.pk_rate / 100) }}%
                </div>
              </div>
              <div class="flex-space-between item-list">
                <div class="flex-flex-start">
                  <img
                    class="icon"
                    src="../../assets/images/winterGame/p4.png"
                  />
                  <div class="name">每局平均奖杯数：</div>
                </div>
                <div class="ranking">
                  {{ (subjectList.average_score || 0) | formatNumberFilter }}
                </div>
              </div>
              <div class="flex-space-between item-list">
                <div class="flex-flex-start">
                  <img
                    class="icon"
                    src="../../assets/images/winterGame/p5.png"
                  />
                  <div class="name">胜/负/平/空/单：</div>
                </div>
                <div class="ranking">
                  <span>{{
                    (subjectList.win_count || 0) | formatNumberFilter
                  }}</span>
                  <span
                    >/{{
                      (subjectList.fail_count || 0) | formatNumberFilter
                    }}</span
                  >
                  <span
                    >/{{
                      (subjectList.flat_count || 0) | formatNumberFilter
                    }}</span
                  >
                  <span
                    >/{{
                      (subjectList.empty_count || 0) | formatNumberFilter
                    }}</span
                  >
                  <span
                    >/{{
                      (subjectList.single_count || 0) | formatNumberFilter
                    }}</span
                  >
                </div>
              </div>
              <div class="flex-space-between item-list">
                <div class="flex-flex-start">
                  <img
                    class="icon"
                    src="../../assets/images/winterGame/p6.png"
                  />
                  <div class="name">累计PK局数：</div>
                </div>
                <div class="ranking">
                  {{ (subjectList.pk_count || 0) | formatNumberFilter }}
                </div>
              </div>
              <div class="passFive" v-if="isGray">过五关斩六将：</div>
              <div class="flex-space-between item-list" v-if="isGray">
                <div class="flex-flex-start">
                  <img
                    class="icon"
                    src="../../assets/images/winterGame/p6.png"
                  />
                  <div class="name">成功/失败/结束：</div>
                </div>
                <div class="ranking">
                  {{ (subjectList.round_challenge.win_count || 0) | formatNumberFilter }}/
                  {{ (subjectList.round_challenge.fail_count || 0) | formatNumberFilter }}/
                  {{ (subjectList.round_challenge.finish_count || 0) | formatNumberFilter }}
                </div>
              </div>
              <div class="flex-space-between item-list">
                <div class="flex-flex-start">
                  <img
                    class="icon"
                    src="../../assets/images/winterGame/p6.png"
                  />
                  <div class="name">累计关卡数：</div>
                </div>
                <div class="ranking">
                  {{ (subjectList.round_challenge.total_count || 0) | formatNumberFilter }}
                </div>
              </div>
              <div class="flex-space-between item-list" style="display: none">
                <div class="flex-flex-start">
                  <img
                    class="icon"
                    src="../../assets/images/winterGame/p7.png"
                  />
                  <div class="name">最多连胜局数：</div>
                </div>
                <div class="ranking">
                  {{
                    (subjectList.continuity_win_count || 0) | formatNumberFilter
                  }}
                </div>
              </div>
            </div>
            <div class="flex-space-around statistical">
              <div class="the-length">
                <div class="num">
                  {{ (subjectList.ques_num || 0) | formatNumberFilter }}
                </div>
                <div class="text">累计做题数</div>
              </div>
              <div class="the-length">
                <div class="num">{{ subjectList.right_rate || 0 }}%</div>
                <div class="text">正答率</div>
              </div>
              <div class="the-length">
                <div class="num">
                  {{
                    Math.floor((subjectList.video_time_length || 0) / 60)
                      | formatNumberFilter
                  }}<span>分钟</span>
                </div>
                <div class="text">累计视频时长</div>
              </div>
              <div class="the-length">
                <div class="num">
                  {{ (subjectList.video_count || 0) | formatNumberFilter
                  }}<span>个</span>
                </div>
                <div class="text">累计视频数</div>
              </div>
              <div class="the-length">
                <div class="num">
                  {{ (subjectList.pk_time_length || 0) | formatNumberFilter
                  }}<span>分钟</span>
                </div>
                <div class="text">PK学习时长</div>
              </div>
              <div class="the-length">
                <div class="num">
                  {{ (subjectList.pk_day_count || 0) | formatNumberFilter
                  }}<span>天</span>
                </div>
                <div class="text">坚持PK天数</div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="emptyData">
              <emptyData />
            </div>
          </template>
        </div>
      </div>
      <!-- 弹出层 -->
      <div class="popup-box" v-if="isTeam">
        <div class="cont-arae">
          <div class="content-li">
            <div class="title">团队贡献</div>
            <ul class="team-name-list">
              <li class="flex-space-around li">
                <div class="ream-column">场次</div>
                <div class="ream-trophy ream-column">奖杯数</div>
                <div class="ream-trophy ream-column">贡献度</div>
                <div class="ream-column">贡献度排名</div>
              </li>
              <li
                class="flex-space-around li"
                v-for="(item, index) in contributionList"
                :key="index"
              >
                <div class="ream-column">{{ item.num }}</div>
                <div class="ream-trophy ream-column">{{ item.trophies }}</div>
                <div class="ream-trophy ream-column">
                  {{ item.contribution }}
                </div>
                <div class="ream-column">{{ item.ranking }}</div>
              </li>
            </ul>
          </div>
          <img
            class="clone"
            src="../../assets/images/winterGame/clone.png"
            @click="handleCloneReam"
          />
        </div>
      </div>
    </div>
    <van-popup style="width: 100%" v-model="isShowPopUpDialog">
      <battalionPoster
        :posterUrl="posterUrl"
        :isShow="isShow"
        @OnCancelPoster="handleCancelPoster"
      >
        <div id="container">
          <invite-pk
            :subjectName="subjectName"
            :inviteUrl="codeUrlImge"
            :posterData="subjectList"
            v-if="isPoster == 1"
          ></invite-pk>
        </div>
      </battalionPoster>
    </van-popup>
  </div>
</template>

<script>
import { Toast } from "vant";
import Header from "../../components/SquirrelCupII/battalionHeader";
import battalionPoster from "../../components/SquirrelCupII/battalion-poster";
import html2canvas from "html2canvas";
import { queryMembers, queryMatchCampus, qrCode } from "../../api/winterGame";
import { getGrayscaleByCampusId } from "@/api/squirrelCup";
import { GetRequest } from "@/util/util";
import emptyData from "@views/WinterGame/components/emptyData.vue";
import InvitePk from "@views/WinterGame/components/poster/invitePk.vue";
export default {
  name: "member-record",
  components: {
    InvitePk,
    emptyData,
    Header,
    battalionPoster,
  },
  data() {
    return {
      isGray: false, // 是否灰度
      isShowPopUpDialog: false, // 是否显示弹出框
      serviceName: "", //服务中心名称
      name: "成员详情",
      isTeam: false,
      isShow: false,
      isPoster: -1,
      posterUrl: "",
      codeUrlImge: "",
      codeUrl: "https://exp4pad.classba.cn/winterGame/register",
      userInfo: {},
      servicePoint: "",
      subjectList: null,
      contributionList: [
        {
          num: "第一场小组赛",
          trophies: 45,
          contribution: 46,
          ranking: 5,
        },
        {
          num: "第一场小组赛",
          trophies: 45,
          contribution: 46,
          ranking: 5,
        },
        {
          num: "第一场小组赛",
          trophies: 45,
          contribution: 46,
          ranking: 5,
        },
      ],
      navTabs: [
        { name: "语文", subjectId: 3 },
        { name: "数学", subjectId: 2 },
        { name: "英语", subjectId: 1 },
      ],
      currentIndex: 0,
      subjectId: 3,
      dataPickerValue: "",
      showPicker: false,
      subActive: 1,
      cupName: "",
      seasonId: "",
      scheduleId: "",
      currentSeason: null,
      currentAcountId: '',
    };
  },

  created() {
    document.title = this.$route.meta.title || "松鼠杯";
    // let getParameters = this.$route.query;
    let getParameters = this.$route.params;
    this.subjectName = getParameters.subject;
    this.currentSeason = getParameters.currentSeason;
    this.currentAcountId = getParameters.accountId;
    this.currentIndex =
      getParameters.subject == "语文"
        ? 0
        : getParameters.subject == "数学"
        ? 1
        : getParameters.subject == "英语"
        ? 2
        : 0;
    this.getParameters = getParameters;
    this.subjectId =
      getParameters.subject == "语文"
        ? 3
        : getParameters.subject == "数学"
        ? 2
        : getParameters.subject == "英语"
        ? 1
        : 3;
    this.seasonId = getParameters.seasonId;
    this.scheduleId = getParameters.scheduleId;
    this.userInfoId = JSON.parse(localStorage.getItem("userInfoId")) || {};
    console.log(getParameters);
  },
  mounted() {
    this.setUserInfo();
    this.getGray();
    this.cupName = this.getParameters.cupName;
    this.serviceName = localStorage.getItem("serviceName");
    if (this.currentUserId) {
      this.initData();
      this.handlePosterSharing();
      this.getServerId();
    }
  },
  methods: {
    // 判断灰度
    getGray() {
      let campusId = JSON.parse(localStorage.getItem("userInfoId")).campusId;
      let param = {
        campusId: campusId, 
        key: 8,
      };
      getGrayscaleByCampusId({ param }).then((res) => {
        if (res.code == 0) {
          this.isGray = res.data;
        }
      });
    },
    setUserInfo() {
      const userInfoId = JSON.parse(localStorage.getItem("userInfoId"));
      if (userInfoId) {
        this.currentUserId = userInfoId.agentUserId;
        this.currentCampusId = userInfoId.campusId;
      } else {
        Toast("找不到参赛信息");
      }
    },
    initData() {
      const { subjectId, userInfoId, getParameters } = this;
      let params = {
        param: {
          currentCampusId: this.currentCampusId,
          currentUserId: this.currentUserId,
          account_id: getParameters.accountId, //学员id
          end_date: "", //结束时间
          scheduleId: this.scheduleId,
          seasonId: this.seasonId,
          start_date: "", // 开始时间
          subject_id: subjectId, //学科
        },
      };
      console.log(params);
      queryMembers(params).then((res) => {
        if (res.code === 0) {
          if (res.data.length > 0) {
            let result = res.data[0];
            result.win_rate = Math.round(Number(result.win_rate || 0) / 100);
            result.right_rate = Math.round(
              Number(result.right_rate || 0) / 100
            );
            this.subjectList = result;
            this.subjectList.service_name = this.serviceName;
          } else {
            this.subjectList = null;
          }

          //
        }
      });
    },
    handleCancelPoster(type) {
      this.isShow = type;
      this.isShowPopUpDialog = false;
    },

    async getServerId() {
      let params = {
        param: { campusId: this.currentCampusId || 88 },
      };
      await queryMatchCampus(params).then((res) => {
        if (res.code === 0) {
          this.servicePoint = res.data || {};
        }
      });
    },
    getCodeUrl() {
      let codeUrl = "https://exp4pad.classba.cn/winterGame/register";
      if (location.port > 3000 || location.host.indexOf(".test") > -1) {
        codeUrl = "https://exp4pad-test.classba.cn/winterGame/register";
      }
      if (location.host.indexOf("-pre") > -1) {
        codeUrl = "https://exp4pad-pre.classba.cn/winterGame/register";
      }

      return codeUrl;
    },
    async handlePosterSharing(type, data = {}) {
      const { userInfoId } = this || {};
      let codeUrl = this.getCodeUrl();
      const url = `${codeUrl}?c=${this.currentCampusId}&f=${this.currentUserId}&s=松鼠杯`;

      const params = { param: url };
      this.posrerData = data;
      await qrCode(params).then((res) => {
        if (res.code === 0) {
          this.codeUrlImge = res.data || "";
        }
      });
    },
    // 分享生成图片
    onSharePlu() {
      Toast.loading({ message: "加载中...", forbidClick: true, duration: 0 });
      this.isPoster = 1;
      this.isShowPopUpDialog = true;
      setTimeout(() => {
        const dom = document.querySelector("#container");
        const targetDom = dom.firstChild;
        const config = {
          useCORS: true,
          logging: true,
          width: targetDom.offsetWidth,
          height: targetDom.offsetHeight - 4,
        };
        html2canvas(targetDom, config).then((canvas) => {
          this.isShow = true;
          this.posterUrl = canvas.toDataURL();
          this.isPoster = -1;
          Toast('长按保存图片');;
        });
      }, 500);
    },
    onConfirm(time) {
      this.dataPickerValue = time;
      this.showPicker = false;
    },
    async handleTabs(index) {
      this.currentIndex = index;
      this.subjectId = await this.navTabs[index].subjectId;
      this.subjectName = await this.navTabs[index].name;
      await this.initData();
    },
    // 团队贡献
    handleContribution() {
      this.isTeam = true;
    },
    // 关闭团队贡献弹出层
    handleCloneReam() {
      this.isTeam = false;
    },
  },
};
</script>

<style lang="less">
@import "../../assets/style/global.less";

.member-detail-wrap {
  position: relative;
  width: 100%;
  // height: 100%;
  padding-bottom: 30px;

  header {
    position: relative;
    .share {
      width: 150px;
      height: 56px;
      background: linear-gradient(135deg, #1b94ff 0%, #23b0ff 100%);
      border-top-left-radius: 28px;
      border-bottom-left-radius: 28px;
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      margin: 0;
      color: #ffffff;
      position: absolute;
      right: -20px;
      top: 0px;
      display: flex;
      justify-content: center;

      span {
        display: block;
        text-align: center;
        line-height: 56px;

        &::before {
          display: inline-block;
          content: "";
          width: 24px;
          height: 24px;
          background: url("../../assets/images/winter/second/shareIcon.png")
            no-repeat center;
          background-size: 100%;
          vertical-align: middle;
          margin-right: 10px;
        }
      }
    }

    h3 {
      height: 44px;
      font-size: 32px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #323232;
      line-height: 44px;
      text-align: center;
    }
    div {
      display: flex;
      align-items: center;
      margin: 32px;
      img {
        width: 128px;
        height: 128px;
      }
      dl {
        flex-grow: 1;
        margin-left: 24px;
        dt {
          height: 50px;
          font-size: 36px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #000000;
          line-height: 50px;
        }
        dd {
          height: 34px;
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          line-height: 34px;
          margin-left: 0;
          display: flex;
          justify-content: space-between;
          a {
            height: 40px;
            font-size: 28px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #58abf6;
            line-height: 40px;
          }
        }
      }
    }
  }

  .base {
  }

  .back {
    position: fixed;
    top: 22px;
    left: 30px;
    width: 136px;
    height: 48px;
    cursor: pointer;
    z-index: 4;

    img {
      display: block;
      width: 100%;
    }
  }

  .btn {
    width: 240px;
    margin: 0 auto;

    span {
      display: inline-block;
      width: 100%;
      background: linear-gradient(90deg, #0374ca 0%, #0091ff 52%, #0374ca 100%);
      border: 1px solid #82c9ff;
      margin: 270px auto 0;
      font-size: 36px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ffffff;
      height: 66px;
      line-height: 66px;
      text-align: center;
    }
  }

  .cont {
    position: relative;
    // width: 686px;
    min-height: 794px;
    margin: 0 32px;
    background: #ffffff;
    border-radius: 8px;
    padding-bottom: 32px;

    .team-contribution {
      position: fixed;
      right: 32px;
      top: 675px;
      width: 208px;
      height: 60px;
      // border-bottom: 2px solid red;
      background: linear-gradient(180deg, #1b94ff 0%, #22acff 100%);
      box-shadow: 0px 8px 12px 0px rgba(0, 149, 255, 0.5);
      border-radius: 176px 0px 0px 176px;

      border-image: linear-gradient(
          360deg,
          rgba(255, 255, 255, 1),
          rgba(255, 255, 255, 0)
        )
        2 2;
      font-size: 32px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ffffff;
      z-index: 6;

      &::after {
        content: "";
        width: 90%;
        height: 2px;
        background: white;
        position: absolute;
        right: 0;
        bottom: 0;
      }
    }

    .row {
      padding: 30px;
    }

    .user-info {
      display: flex;
      // justify-content: space-around;
      align-items: center;

      .avator {
        width: 96px;
        height: 96px;
        border-radius: 50%;
        overflow: hidden;

        .run {
          width: 100%;
          height: 100%;
          background: #22acff;
          color: white;
          font-size: 40px;
        }

        img {
          display: block;
          width: 100%;
        }
      }

      .user {
        margin-left: 10px;

        span {
          display: block;

          &.name {
            height: 50px;
            font-size: 36px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #333333;
            line-height: 50px;
          }

          &.id {
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
          }
        }
      }
    }

    .tabs {
      display: flex;
      padding: 0 30px;
      margin-bottom: 48px;

      .tab-item {
        margin: 0 36px;
        font-size: 32px;
        font-weight: 600;
        color: #999999;

        span {
          position: relative;
        }

        &.active {
          color: #000000;

          span::after {
            content: "";
            width: 40px;
            height: 8px;
            background: linear-gradient(135deg, #1b94ff 0%, #23b0ff 100%);
            border-radius: 5px;
            position: absolute;
            bottom: -18px;
            left: 50%;
            transform: translate(-50%, 0);
          }
        }
      }
    }

    .passFive {
      padding: 30px 56px 30px 26px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 32px;
      color: #000000;
      line-height: 44px;
      font-style: normal;
    }

    .item-list {
      background: rgba(88, 171, 246, 0.08);
      padding: 30px 56px 30px 26px;
      position: relative;
      margin-bottom: 32px;

      &::after {
        content: "";
        width: calc(100% - 56px);
        height: 2px;
        background-color: #eeeeee;
        position: absolute;
        left: 50%;
        bottom: -16px;
        transform: translate(-50%, 0);
      }

      .icon {
        display: block;
        width: 40px;
        height: 40px;
        flex-shrink: 0;
      }

      .name {
        padding-left: 16px;
        font-size: 28px;
        font-weight: 400;
        color: #333333;
      }

      .ranking {
        font-size: 28px;
        font-weight: 600;
        color: #333333;
      }
    }

    .statistical {
      text-align: center;
      border-radius: 16px;
      border: 2px solid #bcd8f3;
      margin: 54px 32px;
      padding-top: 48px;
      box-sizing: border-box;

      &::after {
        content: "";
        flex: auto;
      }

      .the-length {
        width: 33.33%;
        padding-bottom: 48px;

        .num {
          font-size: 40px;
          font-weight: 400;
          color: #323232;
          span {
            font-size: 26px;
          }
        }

        .text {
          font-size: 24px;
          font-weight: 400;
          color: #68707d;
        }
      }
    }
  }
}

/** */
.popup-box {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  z-index: 6;

  .cont-arae {
    position: absolute;
    top: 50%;
    left: 50%;
    width: calc(100% - 98px);
    transform: translate(-50%, -50%);
    z-index: 7;

    .clone {
      display: block;
      width: 58px;
      margin: 46px auto 0 auto;
    }
  }

  .content-li {
    margin: 0 auto;
    background: white;
    border-radius: 8px;
    padding-bottom: 16px;

    .title {
      font-size: 40px;
      font-weight: 600;
      text-align: center;
      padding: 32px 0;
      color: #333333;
    }

    .team-name-list {
      padding: 0;
      margin: 0;
      max-height: 600px;
      overflow-y: auto;

      .li {
        padding: 0;
        margin: 0;
        text-align: center;

        &:not(:first-child) {
          margin: 0 10px;
          border-bottom: 2px solid #eeeeee;
        }

        &:first-child {
          background: #1c96ff;
          color: white;
          border-bottom: none;
        }

        &:last-child {
          border-bottom: none;
        }

        .ream-column {
          padding: 12px 0;
          font-size: 28px;
          width: 24%;

          &.ream-trophy {
            width: 20%;
          }

          &:first-child {
            width: 28%;
          }
        }
      }
    }
  }
}

// 海报
.poster-div-hb {
  // display: none;
  position: absolute;
  // top: 0;
  // left: 0;
  z-index: -1;
  width: 100%;
  background: #090e60;
  padding: 28px 40px;

  .con {
    .logo {
      display: block;
      width: 196px;
    }

    .songshu-dj {
      width: 100%;
      position: relative;
      margin-top: -20px;
    }

    .server-text {
      font-size: 44px;
      font-weight: 600;
      color: #ffffff;
      text-align: center;
      padding: 16px 0 10px 0;
    }

    .arae-block {
      text-align: center;
      background: #0e2270;
      border-radius: 16px;
      padding-top: 16px;

      .name {
        font-size: 44px;
        font-weight: 600;
        color: #ffffff;
        padding-bottom: 10px;
      }

      .subject {
        font-size: 28px;
        font-weight: 400;
        color: #a2aac8;
        width: 80%;
        margin: 0 auto;
      }

      .information {
        .item-li {
          width: 50%;
          padding: 16px 0;

          div:nth-child(1) {
            font-size: 24px;
            font-weight: 400;
            color: #515f97;
            padding-bottom: 16px;
          }

          div:nth-child(2) {
            font-size: 32px;
            font-weight: 600;
            color: #ffffff;
          }
        }
      }
    }

    .songshu-pk {
      display: block;
      width: 444px;
      height: 94px;
      margin: 40px auto 32px auto;
    }

    .code-img {
      width: 196px;
      height: 196px;
      border: 4px solid #e7e8ff;
      margin: 0 auto;

      .pic {
        display: block;
        width: 190px;
        height: 190px;
        margin: 0 auto;
      }
    }

    .long-press {
      font-size: 24px;
      font-weight: 400;
      color: #ffffff;
      text-align: center;
      padding-top: 10px;
    }
  }
}
</style>
